import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation, Types } from '@grandvisionhq/graphql';
import { CREATE_RETURN } from '../operations/mutations/create-return.js';
import { GET_RETURN } from '../operations/queries/get-return.js';

const useCreateReturn = ({ onCompleted , onError  } = {})=>{
    const handleOnCompleted = React.useCallback((result)=>{
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(result);
    }, [
        onCompleted
    ]);
    const [mutation, { called , data , error: error1 , loading  }] = useMutation(CREATE_RETURN, {
        onCompleted: handleOnCompleted,
        onError (error) {
            console.error(error);
            onError === null || onError === void 0 ? void 0 : onError();
        },
        update (cache, { data: createReturnResponse  }) {
            var ref;
            if (createReturnResponse && createReturnResponse.createReturn.return && ((ref = createReturnResponse.createReturn.failures) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                var ref1;
                cache.writeQuery({
                    query: GET_RETURN,
                    data: {
                        getReturn: swcHelpers.objectSpread({}, createReturnResponse === null || createReturnResponse === void 0 ? void 0 : createReturnResponse.createReturn, {
                            __typename: 'GetReturnResponse',
                            return: swcHelpers.objectSpread({}, createReturnResponse === null || createReturnResponse === void 0 ? void 0 : (ref1 = createReturnResponse.createReturn) === null || ref1 === void 0 ? void 0 : ref1.return, {
                                status: Types.ReturnStatus.RETURN_REQUESTED
                            })
                        })
                    }
                });
            }
        }
    });
    // Temporary fix until solution in MACC-18448
    const trigger = function() {
        var _ref = swcHelpers.asyncToGenerator(function*(input) {
            return mutation({
                variables: {
                    input
                }
            });
        });
        return function trigger(input) {
            return _ref.apply(this, arguments);
        };
    }();
    return React.useMemo(()=>[
            trigger,
            {
                called,
                data,
                error: error1,
                loading
            }, 
        ]
    , [
        trigger,
        called,
        data,
        error1,
        loading
    ]);
};

export { useCreateReturn };
//# sourceMappingURL=use-create-return.js.map
